

export const projects = [
  {
    id: 1,
    name:"Spring-Library-API",
    githublink:"https://github.com/Dommy99/spring-library"
  },
  {
    id: 2,
    name:"Anime-Watch-List-API",
    githublink:"https://github.com/Dommy99/anime-watch-list-API"
  },
  {
    id: 3,
    name:"Adopt-Me-API Frontend",
    githublink:"https://github.com/Dommy99/Adopt-Me-frontend"
  },
  {
    id: 4,
    name:"Adopt-Me-API Backend",
    githublink:"https://github.com/Dommy99/Adopt-Me_backend"
  },
  {
    id: 5,
    name:"WaterColor",
    githublink:"https://github.com/Dommy99/crop-duster"
  },
  {
    id: 6,
    name:"Connections",
    githublink:"https://github.com/Dommy99/connections"
  },
  {
    id: 7,
    name:"Readme Generator",
    githublink:"https://github.com/Dommy99/README-Gen"
  },
];
